import React, { useEffect, useState } from "react";
import { isAuthenticated, redirectToLogin } from "../helpers/auth_helper";

const Navdata = () => {
    // State variables
    const [isDashboard, setIsDashboard] = useState(false);
    const [recruitments, setRecruitments] = useState(false);
    const [data_master, setDataMaster] = useState(false); // Added state for Data Master
    const [development, setDevelopment] = useState(false); // Added state for Development
    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    // Check authentication on component mount (simplified)
    useEffect(() => {
        // Let AuthProtected component handle the main auth logic
        // This is just for additional safety
        const authToken = localStorage.getItem('authToken');
        if (!authToken) {
            console.warn('No auth token found in LayoutMenuData');
        }
    }, []);

    // Function to update sidebar icons
    function updateIconSidebar(e: any) {
        if (e?.target?.getAttribute("sub-items")) {
            const parentId = e.target.getAttribute("sub-items");
            const parentMenu = document.getElementById(parentId);

            if (parentMenu) {
                const ul: any = document.getElementById("two-column-menu");
                const iconItems: any = ul.querySelectorAll(".nav-icon.active");
                [...iconItems].forEach((item) => {
                    item.classList.remove("active");
                    const id: any = item.getAttribute("sub-items");
                    const menusId = document.getElementById(id);
                    menusId?.parentElement?.classList.remove("show");
                });

                e.target.classList.add("active");
                parentMenu.parentElement?.classList.toggle("show");
            }
        }
    }

    // Effect to handle state changes
    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
    }, [iscurrentState, isDashboard]);

    // Menu items data
    const menuItems: any = [
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ph-gauge",
            link: "/dashboard",
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Dashboard');
                updateIconSidebar(e);
            },
            stateVariables: isDashboard,
        },
        {
            id: "data_master",
            label: "Data Master",
            icon: "ph-database",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setDataMaster(!data_master); // Corrected to use Data Master state
                setIscurrentState('Data Master');
                updateIconSidebar(e);
            },
            stateVariables: data_master, // Corrected to use Data Master state
            subItems: [
                {
                    id: "religion",
                    label: "Religion",
                    link: "/religion",
                    parentId: "data_master",
                },
                {
                    id: "blood_type",
                    label: "Blood Type",
                    link: "/blood",
                    parentId: "data_master",
                },
                {
                    id: "education",
                    label: "Education",
                    link: "/education",
                    parentId: "data_master",
                },
                {
                    id: "family",
                    label: "Family",
                    link: "/family",
                    parentId: "data_master",
                },
                {
                    id: "job_posting",
                    label: "Job Posting",
                    link: "/job-posting",
                    parentId: "data_master",
                },
                {
                    id: "project",
                    label: "Project",
                    link: "/project",
                    parentId: "data_master",
                },
                {
                    id: "certification",
                    label: "Certification",
                    link: "/sertifikasi",
                    parentId: "data_master",
                },
                {
                    id: "job_position",
                    label: "Job Position",
                    link: "/job-position",
                    parentId: "data_master",
                },
                {
                    id: "questions",
                    label: "Questions",
                    link: "/questions",
                    parentId: "data_master",
                }
            ],
        },
        {
            id: "recruitments",
            label: "Recruitments",
            icon: "ph-briefcase",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setRecruitments(!recruitments);
                setIscurrentState('Recruitments');
                updateIconSidebar(e);
            },
            stateVariables: recruitments,
            subItems: [
                {
                    id: "feedback",
                    label: "Feedback",
                    link: "/transactions/feedback",
                    parentId: "recruitments",
                },
                {
                    id: "job_applicants",
                    label: "Job Applicants",
                    link: "/transactions/job-applicants",
                    parentId: "recruitments",
                },
                {
                    id: "applicant_no_batch",
                    label: "Applicant No Batch",
                    link: "/transactions/applicant-no-batch",
                    parentId: "recruitments",
                },
                {
                    id: "test_results",
                    label: "Test Results",
                    link: "/transactions/test-results",
                    parentId: "recruitments",
                },
                {
                    id: "medical_tests",
                    label: "Medical Tests",
                    link: "/transactions/medical-tests",
                    parentId: "recruitments",
                },
                {
                    id: "training",
                    label: "Training",
                    link: "/transactions/training",
                    parentId: "recruitments",
                },
                {
                    id: "training_attendance",
                    label: "Training Attendance",
                    link: "/transactions/training-attendance",
                    parentId: "recruitments",
                },
                {
                    id: "recall",
                    label: "Recall",
                    link: "/transactions/recall",
                    parentId: "recruitments",
                },
                {
                    id: "project_requests",
                    label: "Project Requests",
                    link: "/transactions/project-requests",
                    parentId: "recruitments",
                },
            ],
        },
        {
            id: "placement",
            label: "Placement",
            icon: "ph-map-pin",
            link: "/placement",
        },
        {
            id: "violations",
            label: "Violations",
            icon: "ph-warning",
            link: "/violations",
        },
        {
            id: "chats",
            label: "Chats",
            icon: "ph-chat",
            link: "/chats",
        },
        {
            id: "settings",
            label: "Settings",
            icon: "ph-gear",
            link: "/settings",
        },
        {
            id: "user_management",
            label: "User Management",
            icon: "ph-users",
            link: "/user-management",
        },
        {
            id: "logs",
            label: "Logs",
            icon: "ph-list-bullets", // Updated icon
            link: "/logs",
        },
        {
            id: "development",
            label: "Development",
            icon: "ph-code",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setDevelopment(!development);
                setIscurrentState('Development');
                updateIconSidebar(e);
            },
            stateVariables: development,
            subItems: [
                {
                    id: "migrations",
                    label: "Migrations",
                    link: "/development/migrations",
                    parentId: "development",
                },
                {
                    id: "modules",
                    label: "Modules",
                    link: "/development/modules",
                    parentId: "development",
                },
                {
                    id: "apis",
                    label: "APIs Documentation",
                    link: "/development/apis",
                    parentId: "development",
                }
            ],
        }
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;